import { tryParseJson } from '@jbhi-fi/utils/src/JSON/tryParseJson';
import resolveResponse from 'contentful-resolve-response';

const getContentfulSkeletonData = () => {
  const dataString = window.Jbhifi?.contentfulDataString;
  if (!dataString) {
    return;
  }
  const parsedData = tryParseJson<{ items?: Array<unknown> }>(decodeURIComponent(dataString));
  if (!parsedData) {
    console.error('Contentful: Invalid contentful data string format');
    return;
  }
  const isResolvable = Array.isArray(parsedData.items);

  const resolvedData = isResolvable ? resolveResponse(parsedData) : [parsedData];
  window.Jbhifi.contentfulData = resolvedData[0];
};

getContentfulSkeletonData();
